var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwoPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 28.004,
    viewBox: "0 0 36 28.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-people",
    "data-name": "Icon open-people",
    d: "M24.75,0a6.558,6.558,0,0,0-5.49,3.077,10.03,10.03,0,0,1,3.24,7.447,9.719,9.719,0,0,1-.405,2.832,6.4,6.4,0,0,0,2.655.664A6.88,6.88,0,0,0,31.5,7.027,6.88,6.88,0,0,0,24.75.035ZM11.25,3.5A6.88,6.88,0,0,0,4.5,10.488a6.88,6.88,0,0,0,6.75,6.992A6.88,6.88,0,0,0,18,10.488,6.88,6.88,0,0,0,11.25,3.5ZM32.625,14.544a11.508,11.508,0,0,1-7.6,2.937A6.963,6.963,0,0,1,27,22.165v2.307h9v-5.8c0-1.818-1.4-3.391-3.375-4.16Zm-29.25,3.5C1.395,18.809,0,20.382,0,22.2V28H22.5V22.2c0-1.818-1.4-3.391-3.375-4.16a11.526,11.526,0,0,1-7.875,2.937A11.7,11.7,0,0,1,3.375,18.04Z",
    fill: "#527991"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoPeople);
export default __webpack_public_path__ + "static/media/twoPeople.557cda15.svg";
export { ForwardRef as ReactComponent };